import { Box, Typography, Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LanOutlinedIcon from "@mui/icons-material/LanOutlined";
import { HEADING_FONT } from "../theme/fonts";
import AddSubdomainForm from "./AddSubdomainForm";

// --- Spec palette (blue · light) ---
const BLUE = "#3B82F6";
const BLUE_DARK = "#1D4ED8";
const HAIRLINE = "#EEF1F6";

// Popup modal for registering / editing a subdomain. The form does the lookup +
// create; this is the flat white dialog shell with a clean header.
function AddSubdomainModal({
  open,
  onClose,
  onSuccess,
  editId = null,
  initialName = "",
  initialIp = "",
  initialPublicIp = "",
  initialPrivateIp = "",
  initialParentId = null,
  initialServerId = null,
  initialCategoryId = null,
  initialSslValidity = null,
  initialSslStatus = "",
  initialStatus = "",
}) {
  const isEdit = editId != null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      slotProps={{
        paper: {
          sx: {
            borderRadius: "16px",
            background: "#fff",
            border: `1px solid ${HAIRLINE}`,
            boxShadow: "0 24px 64px rgba(16, 24, 40, 0.18)",
            backgroundImage: "none",
            overflow: "hidden",
          },
        },
      }}
    >
      {/* Blue gradient header banner */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.75,
          px: 3,
          py: 2.5,
          color: "#fff",
          background: `linear-gradient(135deg, ${BLUE_DARK} 0%, ${BLUE} 100%)`,
        }}
      >
        <Box
          sx={{
            width: 46,
            height: 46,
            borderRadius: "12px",
            background: "rgba(255,255,255,0.18)",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <LanOutlinedIcon sx={{ fontSize: 25 }} />
        </Box>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography sx={{ fontSize: 10.5, fontWeight: 700, letterSpacing: "1.4px", textTransform: "uppercase", opacity: 0.85 }}>
            {isEdit ? "Edit Sub-Domain" : "New Sub-Domain"}
          </Typography>
          <Typography
            sx={{
              fontFamily: HEADING_FONT,
              fontSize: 21,
              fontWeight: 700,
              letterSpacing: "-0.4px",
              lineHeight: 1.15,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {isEdit ? initialName || "Sub-Domain" : "Add Sub-Domain"}
          </Typography>
        </Box>
        <IconButton
          onClick={onClose}
          aria-label="Close"
          sx={{ color: "rgba(255,255,255,0.9)", "&:hover": { background: "rgba(255,255,255,0.15)", color: "#fff" } }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Scrollable body */}
      <Box sx={{ p: 3, maxHeight: "70vh", overflowY: "auto", background: "#fff" }}>
        <AddSubdomainForm
          onSuccess={onSuccess}
          onCancel={onClose}
          editId={editId}
          initialName={initialName}
          initialIp={initialIp}
          initialPublicIp={initialPublicIp}
          initialPrivateIp={initialPrivateIp}
          initialParentId={initialParentId}
          initialServerId={initialServerId}
          initialCategoryId={initialCategoryId}
          initialSslValidity={initialSslValidity}
          initialSslStatus={initialSslStatus}
          initialStatus={initialStatus}
        />
      </Box>
    </Dialog>
  );
}

export default AddSubdomainModal;
